module.exports = {"global":{"$--color-primary":"#2E2E92","$--color-success":"#613493","$--color-warning":"#F27D6B","$--color-danger":"#D13892","$--color-info":"#BCC7CB"},"local":{}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/config.json
// module id = 2LA7
// module chunks = 102